import { render, staticRenderFns } from "./BtDashboardDesigner.vue?vue&type=template&id=492b04f8&scoped=true&"
import script from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
export * from "./BtDashboardDesigner.vue?vue&type=script&lang=js&"
import style0 from "./BtDashboardDesigner.vue?vue&type=style&index=0&id=492b04f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492b04f8",
  null
  
)

export default component.exports